/**
 * Tag color utilities.
 *
 * Each tag already has a `color` hex value persisted in the DB. When one isn't
 * available (e.g. optimistically-added tags before the API responds), we derive
 * a stable color from the tag name using a simple hash over the same palette
 * used by the backend ColorGenerator.
 */

const PALETTE = [
    '#4A90E2', '#7B68EE', '#20B2AA', '#48D1CC', '#3CB371',
    '#FFB347', '#FF6B6B', '#FF69B4', '#BA55D3', '#9370DB',
    '#CD853F', '#FF7F50', '#DC143C', '#B8860B', '#8B008B',
    '#FF8C00', '#9932CC', '#E9967A', '#00CED1', '#9400D3',
    '#1E90FF', '#228B22', '#DAA520', '#4B0082', '#F08080',
    '#FFA07A', '#87CEFA', '#778899', '#C71585', '#663399',
    '#4169E1', '#FA8072', '#2E8B57', '#6A5ACD', '#40E0D0',
    '#059669', '#2563EB', '#7C3AED', '#DC2626',
];

/** Deterministic palette index from string (djb2 hash). */
function hashIndex(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = ((h << 5) + h) ^ str.charCodeAt(i);
        h = h >>> 0;
    }
    return h % PALETTE.length;
}

/** Return the hex color for a tag, falling back to a hash-derived palette color. */
export function getTagColor(tag) {
    const c = tag?.color;
    if (c && /^#[0-9A-Fa-f]{3,8}$/.test(c)) return c;
    return PALETTE[hashIndex((tag?.name || '').toLowerCase())];
}

/**
 * Derive readable chip styles from a hex color:
 *   - light semi-transparent background
 *   - full-strength border and text on "voted" / selected state
 */
export function tagChipStyles(hexColor, voted = false) {
    return {
        bgcolor: voted ? `${hexColor}22` : `${hexColor}12`,
        color: hexColor,
        outline: voted ? `1px solid ${hexColor}` : undefined,
    };
}
